var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Messages',{attrs:{"conversation":_vm.currentConversation,"currentUserId":_vm.currentUserId,"messages":_vm.currentConversationMessages}})}
var staticRenderFns = []

export { render, staticRenderFns }